/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CenterUserControllerExit$Params {

/**
 * 사용자 ID
 */
  userId: string;

/**
 * 센터 ID
 */
  centerId: string;
}

export function centerUserControllerExit(http: HttpClient, rootUrl: string, params: CenterUserControllerExit$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, centerUserControllerExit.PATH, 'patch');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('centerId', params.centerId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

centerUserControllerExit.PATH = '/api/center-user/{centerId}/exit/{userId}';
